<template>
  <div>
    <div v-for="(d, index) in desc" :key="index">
      <v-flex xs12 pb-1>{{ d.description_en }}</v-flex>
      <InvoiceItem v-if="d.subdesc.lenght > 0" :desc="d.subdesc"></InvoiceItem>
    </div>
  </div>
</template>

<script>
export default {
  props: ['desc']
}
</script>

<style lang="scss" scoped></style>
